import {withNamespaces} from "react-i18next";
import React, {useEffect} from "react";
import PropTypes from "prop-types";


const PaymentCardSelection = (props) => {
  const { t } = props;
  console.log('PaymentCardSelection', props);
  useEffect(() => {
    if (!props.default_card.last_four) {
      props.onChange(false);
    }
  }, []);

  return (
    <div className='payment-options'>
      {props.default_card.last_four && (
        <div className='radio'>
          <input type="radio" name="payment" id="use-default" checked={props.use_default} onChange={() => props.onChange(true)}/>
          <label htmlFor="use-default">{props.t('booking_use_card_on_file', {card_number: `**${props.default_card.last_four}`})}</label>
        </div>
      )}
      {props.allowChangeCard && (
        <div className='radio'>
          <input id='use-new' type="radio" name="payment" checked={!props.use_default} onChange={() => props.onChange(false)} />
          <label htmlFor="use-new">{props.t('booking_use_new_card')}</label>
        </div>
      )}
    </div>
  );
};

PaymentCardSelection.propTypes = {
  allowChangeCard: PropTypes.bool,
  default_card: PropTypes.object,
  use_default: PropTypes.bool,
  onChange: PropTypes.func,
};

export default withNamespaces()(PaymentCardSelection);